import { render } from "./Stabling.vue?vue&type=template&id=c1d4d2a8"
import script from "./Stabling.vue?vue&type=script&lang=js"
export * from "./Stabling.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/buildings/Stabling.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c1d4d2a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c1d4d2a8', __exports__)) {
    api.reload('c1d4d2a8', __exports__)
  }
  
  module.hot.accept("./Stabling.vue?vue&type=template&id=c1d4d2a8", () => {
    api.rerender('c1d4d2a8', render)
  })

}


export default __exports__